import { safeLocalStorage } from '@/utils'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
export type TThemeOption = 'light' | 'dark' | 'auto'
export enum EApplicationModal {
  AUTH,
  CONFIRM_BUY_CRYPTO,
  CONFIRM_SELL_CRYPTO,
  PROMPTPAY_PAYMENT_REVIEW_MODAL,
  BUY_EVENT_NOT_PASS,
  TRANSACTION,
  SELL_CRYPTO_TRANSACTION,
  SELL_CRYPTO_FIAT_DISBURSEMENT
}

export type TApplicationVerifyState = {
  verify: EApplicationVerifyModal
  base32?: string
  url?: string
  fn: (code: string) => void
}

export type TApplicationToastState = {
  open: boolean
  type: EApplicationToast
  message: string
}

export enum EApplicationToast {
  SUCCESS,
  FAIL
}

export enum EApplicationCard {
  WALLET_ADDRESS,
  SUMMARY
}

export enum EApplicationVerifyModal {
  VERIFY_2FA,
  VERIFY_2FA_DISABLED
}

export interface IThemeState {
  value: TThemeOption
  loading: boolean
  error: string | null | undefined
}
export interface IApplicationState {
  readonly openModal: EApplicationModal | null
  readonly theme: IThemeState
  readonly showCard: EApplicationCard | null
  readonly verify: TApplicationVerifyState | null
  readonly isApplicationLoading: boolean
  readonly toastApplication: TApplicationToastState | null
}

const initialState: IApplicationState = {
  openModal: null,
  theme: { value: 'light', loading: false, error: null },
  showCard: null,
  verify: null,
  isApplicationLoading: false,
  toastApplication: null
}

export const loadThemeFromLocalStorage = createAsyncThunk(
  'theme/loadFromLocalStorage',
  async (_, { dispatch }) => {
    const storedTheme = safeLocalStorage?.getItem('theme') as TThemeOption
    if (storedTheme) {
      dispatch(setTheme(storedTheme))
    }
  }
)

const applictaionSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setOpenModal(state, action: PayloadAction<EApplicationModal | null>) {
      state.openModal = action.payload
    },
    setTheme(state, action: PayloadAction<TThemeOption>) {
      state.theme.value = action.payload
    },
    setShowCard(state, action) {
      state.showCard = action.payload
    },
    setOpenVerify(state, action) {
      state.verify = action.payload
    },
    setApplicationLoading(state, action) {
      state.isApplicationLoading = action.payload
    },
    setToast(state, action) {
      state.toastApplication = action.payload
    }
  },
  extraReducers(builder) {
    builder.addCase(loadThemeFromLocalStorage.pending, (state) => {
      state.theme.loading = true
      state.theme.error = null
    })
    builder.addCase(loadThemeFromLocalStorage.rejected, (state, action) => {
      state.theme.loading = false
      state.theme.error = action.error.message
    })
    builder.addCase(loadThemeFromLocalStorage.fulfilled, (state) => {
      state.theme.loading = false
    })
  }
})

export const {
  setOpenModal,
  setTheme,
  setShowCard,
  setOpenVerify,
  setApplicationLoading,
  setToast
} = applictaionSlice.actions
export default applictaionSlice.reducer
